import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx("svg", {
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        width: "20pt",
        height: "50.000000pt",
        viewBox: "0 0 49.000000 50.000000",
        preserveAspectRatio: "xMidYMid meet",
        children: /*#__PURE__*/ _jsxs("g", {
            transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
            fill: "#0892d0",
            stroke: "none",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M144 470 c-23 -12 -52 -32 -64 -45 l-23 -25 36 0 c20 0 37 4 37 8 0 5 21 19 47 32 61 30 142 31 204 1 30 -15 38 -17 24 -5 -68 56 -185 71 -261 34z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M42 362 c10 -26 124 -222 128 -222 3 0 18 25 33 55 l29 54 -33 60 -34 61 -63 0 c-35 0 -62 -4 -60 -8z m117 -66 c21 -33 28 -66 13 -66 -7 0 -62 85 -62 95 0 3 6 5 14 5 8 0 24 -15 35 -34z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M216 320 l28 -51 28 46 c15 25 28 47 28 50 0 3 -25 5 -56 5 l-55 0 27 -50z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M255 248 c-39 -68 -71 -125 -73 -128 -1 -3 4 -14 11 -24 13 -18 17 -14 48 42 33 61 35 62 75 62 29 0 44 5 48 16 9 23 8 24 -24 24 -36 0 -37 7 -9 54 18 31 26 36 60 36 28 0 41 5 49 20 10 19 8 20 -53 20 l-63 0 -69 -122z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M454 332 c-35 -58 -54 -95 -41 -79 22 26 27 21 27 -25 0 -55 -38 -136 -79 -171 -41 -34 -29 -35 20 -1 63 44 93 98 97 179 2 39 0 80 -5 92 -8 21 -9 21 -19 5z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M10 285 c-15 -127 61 -240 183 -269 l28 -7 -27 48 c-31 54 -40 66 -31 41 8 -22 4 -22 -31 -4 -59 31 -102 95 -113 166 -3 25 -7 36 -9 25z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M267 143 c-41 -66 -48 -83 -42 -103 4 -11 9 -20 13 -20 4 0 28 36 54 80 46 78 46 80 22 80 -17 0 -31 -11 -47 -37z"
                })
            ]
        })
    });
};
export default Icon;
